import { Typography } from '@material-ui/core'

import {
  RateConnectionChannelFieldsType,
  RateMultiplierForRateConnection,
  RoomTypeForRateConnection
} from '../../types/rateConnection'
import RenderRowValues from './RenderRowValues'
import useStyles from './styles/PriceClassDistributionRateMultiplierRow.styles'

interface PriceClassDistributionRateMultiplierRowProps {
  rateMultiplierData: RateMultiplierForRateConnection
  roomTypeIndex: number
  ratePlanIndex: number
  channelIndex: number
  rateMultiplierIndex: number
  updatedRateConnectionList: RoomTypeForRateConnection[]
  setUpdatedRateConnectionList: React.Dispatch<
    React.SetStateAction<RoomTypeForRateConnection[]>
  >
  weekendIndexes: number[]
  range: 'TWO_WEEKS' | 'MONTH'
  isPersian: boolean
  selectedMenuFieldInChannelRow: RateConnectionChannelFieldsType
}

const PriceClassDistributionRateMultiplierRow: React.FC<
  PriceClassDistributionRateMultiplierRowProps
> = ({
  rateMultiplierData,
  roomTypeIndex,
  ratePlanIndex,
  channelIndex,
  rateMultiplierIndex,
  updatedRateConnectionList,
  setUpdatedRateConnectionList,
  weekendIndexes,
  range,
  isPersian,
  selectedMenuFieldInChannelRow
}) => {
  const classes = useStyles()

  return (
    <div>
      <div
        className={[
          classes.priceClassRow,
          range === 'MONTH' && classes.priceClassRowMonth
        ].join(' ')}>
        <div className={classes.rowNameContainer}>
          <Typography
            variant="h4"
            className={classes.rowName}
            style={isPersian ? { fontFamily: 'IranSans' } : undefined}>
            {rateMultiplierData.name}
          </Typography>{' '}
        </div>
        <span />
        <RenderRowValues
          rowDataRateMultiplier={rateMultiplierData.dataForEachDate}
          roomTypeIndex={roomTypeIndex}
          ratePlanIndex={ratePlanIndex}
          channelIndex={channelIndex}
          priceClassIndex={0}
          rateMultiplierIndex={rateMultiplierIndex}
          updatedRateConnectionList={updatedRateConnectionList}
          setUpdatedRateConnectionList={setUpdatedRateConnectionList}
          weekendIndexes={weekendIndexes}
          selectedMenuFieldInChannelRow={selectedMenuFieldInChannelRow}
        />
      </div>
    </div>
  )
}

export default PriceClassDistributionRateMultiplierRow
